export default __webpack_public_path__ + "static/mobile_2-a3db74ec538a87d6a0294586dfe6b6b1.webp";